import {config} from '../config'

const addDefaultJoinsToRecords = (cacheMissEntries, key, joinDescriptors, {context, seenKeys, buildRecordList}) => {
	if (!cacheMissEntries.length || !joinDescriptors.length) return

	// Batch default joins so shared child records are built once, then reattached in each parent record's own join order.
	joinDescriptors.forEach(joinDescriptor => {
		const {joinedSourceRecordsByEntry, joinedSourceRecords} = collectJoinedSourceRecords(cacheMissEntries, key, joinDescriptor, context)
		const builtRecordBySourceRecord = buildJoinedRecordLookup(joinedSourceRecords, joinDescriptor, {context, seenKeys, buildRecordList})
		attachJoinedRecords(cacheMissEntries, joinDescriptor, joinedSourceRecordsByEntry, builtRecordBySourceRecord)
	})
}

const collectJoinedSourceRecords = (cacheMissEntries, key, joinDescriptor, context) => {
	const joinedSourceRecordsByEntry = []
	const joinedSourceRecords = []
	const seenSourceRecords = new Set()
	const addJoinedSourceRecord = sourceRecord => {
		if (seenSourceRecords.has(sourceRecord)) return
		seenSourceRecords.add(sourceRecord)
		joinedSourceRecords.push(sourceRecord)
	}

	cacheMissEntries.forEach(({sourceRecord}, index) => {
		const joinedRecords = context.resolveJoinRecords({record: sourceRecord, parentKey: key, joinDescriptor})
		if (!joinedRecords) return
		const joinSourceRecords = joinDescriptor.isMultiple ? joinedRecords : [joinedRecords]
		joinedSourceRecordsByEntry[index] = joinSourceRecords
		joinSourceRecords.forEach(addJoinedSourceRecord)
	})

	return {joinedSourceRecordsByEntry, joinedSourceRecords}
}

const buildJoinedRecordLookup = (joinedSourceRecords, joinDescriptor, {context, seenKeys, buildRecordList}) => {
	let builtJoinedRecords = []
	if (joinedSourceRecords.length) {
		builtJoinedRecords = buildRecordList({
			context,
			key: joinDescriptor.key,
			records: joinedSourceRecords,
			seenKeys,
		})
	}

	const builtRecordBySourceRecord = new Map()
	joinedSourceRecords.forEach((sourceRecord, index) => builtRecordBySourceRecord.set(sourceRecord, builtJoinedRecords[index]))
	return builtRecordBySourceRecord
}

const attachJoinedRecords = (cacheMissEntries, joinDescriptor, joinedSourceRecordsByEntry, builtRecordBySourceRecord) => {
	cacheMissEntries.forEach(({modelInstance}, index) => {
		const joinSourceRecords = joinedSourceRecordsByEntry[index]
		if (!joinSourceRecords) return
		const joinedRecords = joinSourceRecords.map(sourceRecord => builtRecordBySourceRecord.get(sourceRecord))
		modelInstance[joinDescriptor.associationKey] = joinDescriptor.isMultiple ? config.createAssociation(joinedRecords) : joinedRecords[0]
	})
}

export {addDefaultJoinsToRecords}
